import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/**
 *
 */
export default class Actions extends React.Component {
	/**
	 *
	 */
	constructor(props) {
		super(props);

		this.options = [
			{ type: 'edit', icon: 'edit', label: 'label.edit' },
			{ type: 'duplicate', icon: 'file', label: 'label.duplicate' },
			{ type: 'remove', icon: 'delete', label: 'label.remove' }
		];

		this.onClick = this.onClick.bind(this);
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		const rows = this.options.map((option, index) => {
			if (this.props.hideTypes.indexOf(option.type) >= 0) {
				return null;
			}

			return (
				<div
					key={`ac-${index}`}
					className="actions__action"
					data-type={option.type}
					onClick={this.onClick}>
					<i className={`icon icon--${option.icon}-black`} />
					<FormattedMessage id={option.label} />
				</div>
			);
		});

		return <div className="actions">{rows}</div>;
	}

	onClick(e) {
		e.preventDefault();
		const action = e.currentTarget.dataset.type;
		this.props.onSelect(action);
	}
}

Actions.propTypes = {
	onSelect: PropTypes.func.isRequired,
	hideTypes: PropTypes.array
};

Actions.defaultProps = {
	hideTypes: []
};
